import React, { useState, useEffect, useContext } from 'react'
import { Main } from '@orbitalgaming/games-frontend-library'
import { CyberWrapper } from './CyberStyles'
import ScoreBoard from '../components/scoreboard/ScoreBoard'
import Balance from '../components/balance/Balance'
import Configs from '../components/configs/Configs'
import Chart from '../components/chart/Chart'
import useUpdateBalance from '../helpers/useUdateBalance'
import useSound from 'use-sound'
import Bet from '../lib/audio/bet.mp3'
import OverUnder from '../lib/audio/overUnder.mp3'
import { MyContext } from '../context/createContext'
import { Currencies } from '../helpers/currency/getCurrencySymbol'

export default function Game({
  blur,
  handleAbove,
  handleRoundId,
  handlePopup,
  sendSocketMessage,
  showLoader,
  history,
  handleSetAutoConfig,
  errorCode,
  audio,
}: any) {
  const { context } = useContext(MyContext)
  const {
    handleRollUnderValue,
    sliderValue,
    rollUnder,
    bet,
    handleManualConfigs,
    auth,
    settings,
  } = context

  const {
    balance,
    balance: { currency },
  } = auth
  const [autoConfig, setAutoConfig] = useState(false)
  const [focused, setFocus] = useState(false)
  const [animate, setanimate] = useState(true)
  const [win, setWin] = useState('0')
  const prec = Currencies[currency] ? Currencies[currency].precision : 2
  const handleRollUnder = () => {
    !audio?.isSoundOff && OverUnderSFX()
    rollUnder == '1'
      ? (handleRollUnderValue('0'), setanimate(false))
      : (handleRollUnderValue('1'), setanimate(true))
  }

  useEffect(() => {
    const up = settings.over_or_under == '1' ? '1' : '0'
    handleManualConfigs({
      stake: settings.stake,
      sliderValue: settings.bankroll,
      rollUnder: up,
    })
  }, [settings])

  //true is auto configs are in ui, false if back to manual or setautoplay
  const handleAutoConfigs = (b: boolean) => setAutoConfig(b)

  const focusedHandler = (value: boolean) => setFocus(value)

  const finalBalance = useUpdateBalance(balance.amount, bet.balance)

  const [BetSFX] = useSound(Bet, {
    volume: audio?.sound ? parseFloat(audio.sound) / 100 : 0,
  })
  const [OverUnderSFX] = useSound(OverUnder, {
    volume: audio?.sound ? parseFloat(audio.sound) / 100 : 0,
  })
  const playClick = () => {
    !audio?.isSoundOff && BetSFX()
  }

  const winHandler = (s: string) => s > '0' && setWin(s)

  return (
    <Main blur={blur} padding='21px 30px 10px'>
      <CyberWrapper showLoader={showLoader}>
        <ScoreBoard
          roll={sliderValue}
          autoConfig={autoConfig}
          handleAbove={handleAbove}
          handleRoundId={handleRoundId}
          handlePopup={handlePopup}
          sendSocketMessage={sendSocketMessage}
          history={history}
          isLoaded={showLoader}
          animate={animate}
          audio={audio}
          win={win}
          prec={prec}
        />
        <Chart
          value={sliderValue}
          bet={bet}
          focused={focused}
          autoConfig={autoConfig}
          history={history}
        />
        <Configs
          handleRollUnder={handleRollUnder}
          handleAbove={handleAbove}
          autoConfig={autoConfig}
          handleAutoConfigs={handleAutoConfigs}
          playClick={playClick}
          focusedHandler={focusedHandler}
          focused={focused}
          handleSetAutoConfig={handleSetAutoConfig}
          errorCode={errorCode}
          finalBalance={finalBalance}
          audio={audio}
          winHandler={winHandler}
          prec={prec}
        />
        <Balance balance={finalBalance} currency={currency} />
      </CyberWrapper>
    </Main>
  )
}
